var _defs, _circle, _path, _path2, _path3, _path4, _circle2, _path5, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle0, _line, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSmileicon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 98 98",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #a9c7d2;\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-4, .cls-5, .cls-6 {\n        stroke: #167092;\n      }\n\n      .cls-1, .cls-5 {\n        stroke-width: 2px;\n      }\n\n      .cls-2, .cls-3, .cls-4, .cls-5 {\n        fill: none;\n      }\n\n      .cls-3 {\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 1.5px;\n      }\n\n      .cls-7 {\n        fill: rgba(22, 112, 146, .3);\n      }\n\n      .cls-8 {\n        fill: rgba(22, 112, 146, .2);\n      }\n\n      .cls-9, .cls-6 {\n        fill: #167092;\n      }\n\n      .cls-4 {\n        stroke-width: .8px;\n      }\n\n      .cls-10 {\n        fill: #ff8300;\n        stroke: #ebf4f4;\n        stroke-width: .5px;\n      }\n\n      .cls-11 {\n        fill: url(#linear-gradient);\n        fill-opacity: .07;\n      }\n\n      .cls-12 {\n        fill: rgba(255, 255, 255, .61);\n      }\n\n      .cls-6 {\n        fill-rule: evenodd;\n        stroke-width: .3px;\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 48.76,
    y1: 100,
    x2: 49.33,
    y2: -17.15,
    gradientTransform: "translate(0 100) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#009b94"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009b94",
    stopOpacity: 0
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-11",
    cx: 49,
    cy: 49,
    r: 49
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M36.07,26.22c0-1.66,1.34-3,3-3h16.73v41.8h-31.82v-27.57c0-1.66,1.34-3,3-3h6.09c1.66,0,3-1.34,3-3v-5.23Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M60.95,68.79V27.12c0-.74-.62-1.34-1.37-1.34h-2.32v37.75c0,1.65-1.38,3-3.08,3h-27.47s0,2.26,0,2.26c0,.74.62,1.34,1.37,1.34h31.49c.76,0,1.38-.6,1.38-1.34ZM21.31,63.53c0,.74.62,1.34,1.38,1.34h31.49c.76,0,1.37-.6,1.37-1.34V21.86c0-.74-.62-1.34-1.37-1.34h-21.25s-.05,0-.07,0v8.46c0,1.54-1.28,2.79-2.86,2.79h-8.68s0,.05,0,.07v31.69ZM31.15,21.69v7.29c0,.62-.52,1.13-1.16,1.13h-7.48l8.64-8.42ZM59.58,24.12h-2.32v-2.26c0-1.65-1.38-3-3.08-3h-21.25c-.83,0-1.59.3-2.18.88l-10.24,9.98c-.59.58-.9,1.31-.9,2.12v31.69c0,1.65,1.38,3,3.08,3h2.32v2.26c0,1.65,1.38,3,3.08,3h31.49c1.7,0,3.08-1.35,3.08-3V27.12c0-1.65-1.38-3-3.08-3Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M45.44,49.93h0c-3.5,3.58-9.24,3.65-12.83.15l-.15-.15"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M52.05,23.22h3.74v39.8c0,1.1-.9,2-2,2h-1.74V23.22Z"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 56.73,
    cy: 66.59,
    r: 9.05
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M79.75,42.82l-11.41-10.45c2.16-3.2,3.02-7.11,2.39-10.92-.63-3.81-2.69-7.24-5.76-9.58-3.07-2.34-6.93-3.41-10.76-2.99-3.84.42-7.37,2.29-9.87,5.24-2.5,2.94-3.78,6.73-3.57,10.59.21,3.86,1.88,7.49,4.68,10.15,2.8,2.66,6.51,4.14,10.37,4.15,3.86,0,7.58-1.47,10.38-4.12l11.36,10.46c.17.14.36.25.57.32.21.07.43.09.65.08.22-.02.44-.08.63-.18.2-.1.37-.24.51-.41.28-.34.41-.77.38-1.2-.04-.43-.24-.84-.56-1.12ZM56.83,35.64c-2.31.19-4.63-.32-6.66-1.45s-3.68-2.84-4.74-4.91c-1.06-2.07-1.48-4.4-1.22-6.71.27-2.31,1.21-4.49,2.72-6.26,1.5-1.77,3.5-3.06,5.73-3.69,2.23-.64,4.61-.6,6.82.12,2.21.71,4.16,2.07,5.6,3.89,1.44,1.82,2.31,4.03,2.5,6.35.25,3.11-.74,6.19-2.76,8.56-2.02,2.37-4.89,3.85-8,4.1Z"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-12",
    cx: 55.88,
    cy: 23.92,
    r: 11.83
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-9",
    cx: 73.26,
    cy: 48.8,
    r: 1.25
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-9",
    cx: 82,
    cy: 31.33,
    r: 1.25
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-9",
    cx: 73.26,
    cy: 19.48,
    r: 1.25
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-9",
    cx: 13.99,
    cy: 46.93,
    r: 1.25
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-9",
    cx: 33.96,
    cy: 14.49,
    r: 1.25
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 78.26,
    cy: 67.52,
    r: 2.5
  })), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 17.11,
    cy: 20.73,
    r: 2.5
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 9,
    y1: 79,
    x2: 89.49,
    y2: 79
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M83.31,51.3v2.56h-2.56"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M85.44,51.3v2.56h2.56"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M83.31,58.54v-2.56h-2.56"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M85.44,58.54v-2.56h2.56"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M53.79,66.95l2.35,2.35,3.53-5.29"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M33.62,42.76s.08.07.17.14c.03.05.06.11.08.16-.05,0-.02.01.01.03.18.42.28.91.65,1.06.03.01.05.02.08.03.03.03.06.05.09.08,0,0,0-.02-.02-.06.63.16.4-.75.28-1.06-.51-1.31-2.13-2.41-3.54-1.68-.63.33-1.23.93-1.45,1.61-.03.09-.03.5.03.79,0,.03-.01.05-.02.07,0,0,0,0,.02,0v.04s-.02,0-.03-.02c-.04.19,0,.32.19.31-.44.03.13,0-.12.12.25-.11.4-.04.5-.17-.1.12.25-.69.5-1.14.07-.1.13-.19.2-.28.02,0,.04,0,.05,0,0-.03-.02-.03-.04-.01.02-.03.05-.06.07-.09.15-.04.42-.26.49-.31-.58.35.34-.22.22-.21.03,0,.68.17.84.21.22.01.22-.03,0-.12-.01.07-.03.07-.05,0,.02-.02.04-.04.06-.06.06.02.12.04.18.07-.02.09.07.19.19.27.12.09.26.15.32.17.01.02.02.04.02.05.01-.02,0-.03,0-.04.02,0,.03,0,.02-.01ZM30.22,44.24s0-.02,0-.04c.01,0,.03,0,.04,0,.05.04.03.05-.05.05ZM30.56,43.86s.03-.04.04-.06c0,.03-.02.05-.04.06ZM32.58,42.29s.02-.21,0,0h0ZM32.75,42.32c.03-.07.04-.06.04,0h-.04ZM33.2,42.38s.01,0,.02,0c-.02.01-.02,0-.02,0ZM33.37,42.61c-.18-.03-.09-.08,0,0h0ZM33.47,42.63s0-.02,0,0c.02-.07.05.02,0,0Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M33.42,42.83s-.13-.05-.17.03c-.06.12.18-.03.17-.03Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M32.6,42.55c-.04.25.2-.06.2-.05-.02,0-.19-.04-.2.05Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M31.4,42.93s.05-.07,0-.09c0,0-.04.07,0,.09Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M41.96,44c-.47.11.16,0-.11.13.25-.13.4-.07.48-.23-.1.19.39-1.29.55-1.48-.03,0-.06,0-.08,0,.03-.04.06-.08.09-.12.04.04.22.01.39-.02-.44.44.74-.35.53-.36.1,0,.7.19.89.24.09.03.36-.01,0-.12-.02.07-.03.07-.06.01.02-.02.04-.03.06-.05.08.03.15.06.22.09.04.37.35.38.53.39.01.02.03.03.04.04-.02.02.01.05.02.06,0,0,0-.01,0-.02.06.09.11.19.15.3-.07-.02,0,.06.03.08.02.06.04.12.06.19-.02-.01-.03-.02-.03-.03,0,.02.02.03.04.05.06.24.1.5.14.73.11.65,1.16.35.99-.27-.43-1.55-1.46-2.74-3.18-2.63-.68.04-1.26.4-1.67.94-.13.17-.26.89-.25,1.4-.05.13-.08.25-.1.35,0,0,.02,0,.06.01v.05s-.05-.04-.06-.05c-.03.22.04.35.27.33ZM41.99,43.93s0-.12.05-.05c.04.03.03.04-.05.05ZM43.22,42.14s-.02-.13,0,0h0ZM43.26,42.01s.03.06.01.07c-.02-.02-.02-.04-.01-.07ZM44.36,42s.02-.21,0,0h0ZM44.54,42.03c.03-.06.04-.06.04,0h-.04ZM43.97,41.86s0,0-.01-.01c0,0,.01,0,.01.01ZM45.17,42.34s0,0,.02.01c-.19-.05-.09-.07-.02-.01ZM45.29,42.38s0-.02,0,0c.03-.07.05.02,0,0Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M45.55,42.71s-.06-.07-.12,0c-.07.08.11.03.12,0Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M43.01,42.53s.05-.06,0-.09c0,0-.04.06,0,.09Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmileicon);
export default __webpack_public_path__ + "static/media/smileicon.d1413922f1c8845bb722d6b8bf8575c3.svg";
export { ForwardRef as ReactComponent };